import { createGettext } from "vue3-gettext";
import translations from "@/language/translations.json";
import StorageService from "./services/storage.service";

const gettext = createGettext({
  availableLanguages: {
    en: "English",
    sl: "Slovenščina",
  },
  defaultLanguage: "sl",
  mutedLanguages: ["en"],
  globalProperties: {
    pgettext: ["$pgettext", "$t"],
  },
  translations: translations,
  silent: process.env.NODE_ENV == "production",
});

gettext.current = StorageService.get("olaii_guestlist_language") || "sl";

export default gettext;
